import L from "leaflet";

const shopIcon = (shopId) => {
	return new L.divIcon({
		iconSize: new L.Point(40, 40),
		iconAnchor: [20, 23],
		tooltipAnchor: [20, -25],
		className: "map-icon",
		html:
			'<div id="marker-shop-' +
			shopId +
			'"><svg width="40" height="40" version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" xml:space="preserve" fill="currentColor"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} </style> <path d="M16,3C10.5,3,6,7.5,6,13c0,8.4,9,15.5,9.4,15.8c0.2,0.1,0.4,0.2,0.6,0.2s0.4-0.1,0.6-0.2C17,28.5,26,21.4,26,13 C26,7.5,21.5,3,16,3z M19,17c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2h-2v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-6c0-0.6,0.4-1,1-1s1,0.4,1,1v2h2v-2 c0-0.6,0.4-1,1-1s1,0.4,1,1V17z"></path> </g></svg></div>',
	});
};

export { shopIcon };
